import IconButton from "@material-ui/core/IconButton";
import Flag from "react-flags";
import getFlagName from "../../helper/GetFlagName";
import { Menu, MenuItem } from "@material-ui/core";
import cloudStore from "../../store/CloudStore";
import React from "react";
import withIntl from "../../utils/withIntl";

function TranslationSelection(props) {
  const [anchorLanguages, setAnchorLanguages] = React.useState(null);

  const handleClick = (language) => {
    setAnchorLanguages(null);
    props.handleClickLanguage(language);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: 10 }}>
      <IconButton size={"small"} onClick={(event) => setAnchorLanguages(event.currentTarget)}>
        <Flag name={getFlagName(props.currentLanguage)} format="png" pngSize={16} shiny={true} basePath={"/flags"} />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorLanguages}
        keepMounted
        open={Boolean(anchorLanguages)}
        onClose={() => setAnchorLanguages(null)}
      >
        <MenuItem onClick={() => handleClick(cloudStore.merchant.default_language)}>
          <Flag
            name={getFlagName(cloudStore.merchant.default_language)}
            format="png"
            pngSize={16}
            shiny={true}
            basePath={"/flags"}
          />
          {props.intl.formatMessage({ id: cloudStore.merchant.default_language })}
        </MenuItem>
        {cloudStore.merchant.languages
          ?.filter((language) => language.active)
          .map(
            (language) =>
              language.language !== cloudStore.merchant.default_language && (
                <MenuItem onClick={() => handleClick(language.language)}>
                  <Flag
                    name={getFlagName(language.language)}
                    format="png"
                    pngSize={16}
                    shiny={true}
                    basePath={"/flags"}
                  />
                  {props.intl.formatMessage({ id: language.language })}
                </MenuItem>
              )
          )}
      </Menu>
    </div>
  );
}

export default withIntl(TranslationSelection);
